export default __webpack_public_path__ + "static/media/main.454a2863.md";